export default __webpack_public_path__ + "static/media/avalanche_horizontal.3faadab5.png";